import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { Box, Typography } from "@mui/material";
import React from "react";

function ProfileDropdown({
  title,
  itemList,
  selectedItem,
  handleClick,
  isEcdd = false,
}) {
  return (
    <Box sx={{ margin: "16px 16px 0" }}>
      <Typography
        color="textPrimary"
        sx={{
          fontSize: "20px",
          fontWeight: "700",
          lineHeight: 1.4,
          marginBottom: "16px",
        }}
      >
        {title}
      </Typography>
      {itemList.map((item, index) => {
        return (
          <Box
            key={index}
            onClick={() =>
              isEcdd
                ? handleClick({ code: item.code, text: item.name })
                : handleClick(item.code)
            }
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: "32px 0",
              justifyContent: "space-between",
            }}
          >
            <Typography
              color="textPrimary"
              sx={{
                fontWeight: "700",
              }}
            >
              {item.name ? item.name : item.description}
            </Typography>
            {(isEcdd
              ? selectedItem.code === item.code
              : selectedItem === item.code) && (
              <DoneOutlinedIcon
                sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}

export default ProfileDropdown;
